<template>
    <div :style="containerBg" class="aboutitem-container">
        <title-item :title="titleList[2]"></title-item>
        <div class="txt">{{txtDiscription}}</div>
    </div>
</template>

<script>
import data from '@/data/index.json'

export default {
    data() {
        return {
            titleList: data.titleList,
            containerBg: `background-image: url(${require('@/assets/img/aboutItem.png')})`,
            txtDiscription: '本网站用于展示广州锐动网络科技有限公司的基本信息与联系方式。具体服务内容、交付范围和双方权利义务，以实际签署的合同及确认文件为准。',
        }
    },
}
</script>



<style lang="less" scoped>
.txt {
    max-width: @baseW;
    margin: auto;
    text-align: center;
    padding: 0 10px 100px;
    color: #fff;
}
</style>
